<div class="container-fluid" cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
  <div class="row col-12">
    <div class="alert alert-info  col-12 m-md ">
      <span #messageContainer [innerHtml]="this.message"></span>
    </div>
  </div>
  <div class="col-12 d-flex justify-content-end m-b-md">
    <button (click)="close()" class="btn btn-xs btn-secondary" type="button" appFocusControl tabindex="1">
      <i class="fas fa-times" aria-hidden="true"></i> {{ this.buttonKey| translate }} </button>
  </div>
</div>